import React from 'react';

import './page.css';

export const Page = (props) => {
  return <><div className={`page ${props.className}`}>
    {props.children}
  </div>
  <div className="page-break"></div>
  </>
}
